import { useEffect } from "react";
import { SiteNav, SiteFooter } from "@/components/site/SiteChrome";
import { CustomerProof } from "@/components/site/CustomerProof";
import { AcademyCaseStudy } from "@/components/site/AcademyCaseStudy";
import { CohortStories } from "@/components/site/CohortStories";
import { useLandingLang } from "@/components/FundingCaseStudy";
import { usePageMeta } from "@/lib/seo";

const T = {
  en: { meta: { title: "Customer stories | GrantVerify", description: "Real stories from small business owners and nonprofits using GrantVerify to find grants, map the steps, write proposals and get licensed. Share yours.", path: "/customers" },
    eyebrow: "Customers", title: "Real people, real grant work.", sub: "We only publish stories customers send us and agree to share. No stock quotes, no borrowed logos." },
  es: { meta: { title: "Historias de clientes | GrantVerify", description: "Historias reales de dueños de pequeños negocios y organizaciones sin fines de lucro que usan GrantVerify para encontrar subvenciones, trazar los pasos, redactar propuestas y obtener licencias.", path: "/customers" },
    eyebrow: "Clientes", title: "Personas reales, trabajo real con subvenciones.", sub: "Solo publicamos historias que los clientes nos envían y aceptan compartir. Sin citas inventadas ni logotipos prestados." },
};

export default function Customers() {
  const lang = useLandingLang();
  const L = T[lang];
  usePageMeta(L.meta);
  useEffect(() => { if (window.location.hash) setTimeout(() => document.querySelector(window.location.hash)?.scrollIntoView({ behavior: "smooth" }), 300); }, []);
  return (
    <div className="bg-slate-50 min-h-screen" data-testid="customers-page">
      <SiteNav />
      <main data-no-translate lang={lang}>
        <section className="grid-bg border-b border-slate-200"><div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="eyebrow mb-4">{L.eyebrow}</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900 max-w-3xl" data-testid="customers-title">{L.title}</h1>
          <p className="mt-6 text-lg text-slate-600 max-w-2xl">{L.sub}</p>
        </div></section>
        <CustomerProof />
        <AcademyCaseStudy />
        <CohortStories />
      </main>
      <SiteFooter />
    </div>
  );
}
